<template>
  <div class="vheight InformationDetailPropertyEnterprisesList">
    <div
      class="header-seacher"
      v-resize="redraw"
      :inline="true"
      style="border-bottom: 0px dotted #797979"
    >
      <el-tabs
        style="margin-top: 10px"
        type="border-card"
        v-model="activeName"
        @tab-click="handleClick"
      >
        <el-tab-pane label="物业企业详情" name="first"></el-tab-pane>
        <el-tab-pane label="在管项目列表" name="third"></el-tab-pane>
        <el-tab-pane
          :label="isHeaderCompany ? '下属企业' : '隶属企业'"
          name="three"
        ></el-tab-pane>
        <!-- <el-tab-pane label="从业人员列表" name="second"></el-tab-pane>
        <el-tab-pane label="良好业绩" name="four"></el-tab-pane>
        <el-tab-pane label="表彰信息" name="five"></el-tab-pane>
        <el-tab-pane label="不良行为" name="sex"></el-tab-pane>
        <el-tab-pane label="判决仲裁" name="seven"></el-tab-pane>
        <el-tab-pane label="行政处罚" name="eight"></el-tab-pane> -->
      </el-tabs>
    </div>

    <div
      class="container-boot"
      :style="{ height: 'calc(100%)' }"
      style="padding-right: 10px; padding-left: 10px"
    >
      <div
        class="PublicInformationDetail"
        v-show="activeName === 'first'"
        style="padding-left: 0px; padding-right: 0px"
        v-loading="detailLoading"
        element-loading-text="数据正在加载中，请稍候"
      >
        <div class="basInfo-table" :style="{ height: 'calc(100% - -3px)' }">
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">
              统一社会信用代码
            </div>
            <div class="col-define col-xs-4 col-md-4">
              {{ propertyEnterpriseDetails.OrgCode || '--' }}
            </div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">
              物业企业名称
            </div>
            <div class="col-define col-xs-4 col-md-4">
              {{ propertyEnterpriseDetails.OrgName || '--' }}
            </div>
            <!-- </div>
          <div class="row"> -->
            <div class="col-define col-tips col-xs-2 col-md-2">
              物业办公地址
            </div>
            <div class="col-define col-xs-4 col-md-4">
              {{ propertyEnterpriseDetails.Address || '--' }}
            </div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">所属</div>
            <div class="col-define col-xs-4 col-md-4">
              {{
                propertyEnterpriseDetails.IsLocal
                  ? '本地企业'
                  : '外地企业' || '--'
              }}
            </div>
            <!-- </div>
          <div class="row"> -->
            <div class="col-define col-tips col-xs-2 col-md-2">企业性质</div>
            <div class="col-define col-xs-4 col-md-4">
              {{
                propertyEnterpriseDetails.Relations ? '非独立法人' : '独立法人'
              }}
            </div>
          </div>
          <div class="row">
            <!-- <div class="col-define col-tips col-xs-2 col-md-2">营业执照注册号</div>
            <div
              class="col-define col-xs-4 col-md-4"
            >{{propertyEnterpriseDetails.BusinessLicenseNo}}</div>-->
            <div class="col-define col-tips col-xs-2 col-md-2">注册资本</div>
            <div class="col-define col-xs-4 col-md-4">
              {{ propertyEnterpriseDetails.RegCapital || '--' }}（万元）
            </div>
            <!-- </div>
          <div class="row"> -->
            <div class="col-define col-tips col-xs-2 col-md-2">成立日期</div>
            <div class="col-define col-xs-4 col-md-4">
              <span v-if="propertyEnterpriseDetails.RegisteredDate">
                {{
                  propertyEnterpriseDetails.RegisteredDate
                    | formatDate('yyyy-MM-dd')
                }}
              </span>
              <span v-else>--</span>
            </div>
            <!-- <div class="col-define col-tips col-xs-2 col-md-2">联系电话</div>
            <div class="col-define col-xs-4 col-md-4">{{propertyEnterpriseDetails.OfficePhone}}</div> -->
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">法定代表人</div>
            <div class="col-define col-xs-4 col-md-4">
              {{ propertyEnterpriseDetails.LegalRep || '--' }}
            </div>
            <!-- <div class="col-define col-tips col-xs-2 col-md-2">联系手机</div>
            <div class="col-define col-xs-4 col-md-4">{{propertyEnterpriseDetails.LegalRepTel}}</div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">营业执照有效期</div>
            <div
              class="col-define col-xs-4 col-md-4"
            >{{propertyEnterpriseDetails.BusinessLicenseValidTime | formatDate('yyyy-MM-dd')}}</div>
            <div class="col-define col-tips col-xs-2 col-md-2">注册辖区</div>
            <div class="col-define col-xs-4 col-md-4">{{propertyEnterpriseDetails.RegisteredArea}}</div>
          </div>
          <div class="row"> -->
            <div class="col-define col-tips col-xs-2 col-md-2">
              登记注册类型
            </div>
            <div class="col-define col-xs-4 col-md-4">
              {{
                propertyEnterpriseDetails.RegisteredType
                  ? registrationType[propertyEnterpriseDetails.RegisteredType]
                  : '--'
              }}
            </div>
            <!-- <div class="col-define col-tips col-xs-2 col-md-2">企业类别</div>
            <div
              class="col-define col-xs-4 col-md-4"
            >{{companyType[propertyEnterpriseDetails.CompanyType]}}</div> -->
          </div>
          <!-- <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">控股情况</div>
            <div
              class="col-define col-xs-4 col-md-4"
            >{{holdingSituation[propertyEnterpriseDetails.HoldingSituation]}}</div>
            <div class="col-define col-tips col-xs-2 col-md-2"></div>
            <div
              class="col-define col-xs-4 col-md-4"
            ></div> -->
          <!-- <div class="col-define col-tips col-xs-2 col-md-2">执行会计制度类别</div>
            <div
              class="col-define col-xs-4 col-md-4"
            >{{accountingType[propertyEnterpriseDetails.AccountingType]}}</div> -->
          <!-- </div> -->
          <!-- <div class="row"> -->
            <!-- <div class="col-define col-tips col-xs-2 col-md-2">机构类型</div>
            <div
              class="col-define col-xs-4 col-md-4"
            >{{organizationType[propertyEnterpriseDetails.OrganizationType]}}</div> -->
            <!-- <div class="col-define col-tips col-xs-2 col-md-2">
              资质证书编号
            </div>
            <div class="col-define col-xs-4 col-md-4">
              {{ propertyEnterpriseDetails.LicenseNo || '--' }}
            </div> -->
            <!-- </div>
          <div class="row"> -->
            <!-- <div class="col-define col-tips col-xs-2 col-md-2">原资质等级</div>
            <div class="col-define col-xs-4 col-md-4">
              {{ propertyEnterpriseDetails.LicenseLevel || '--' }}
            </div> -->
            <!-- <div class="col-define col-tips col-xs-2 col-md-2">资质证书发证机关</div>
            <div class="col-define col-xs-4 col-md-4">{{propertyEnterpriseDetails.IcenseIssueOrg}}</div> -->
          <!-- </div> -->
          <!-- <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">企业传真</div>
            <div class="col-define col-xs-4 col-md-4">{{propertyEnterpriseDetails.FaxNumber}}</div>
            <div class="col-define col-tips col-xs-2 col-md-2">email</div>
            <div class="col-define col-xs-4 col-md-4">{{propertyEnterpriseDetails.Email}}</div>
          </div> -->
          <!-- <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">主营业范围</div>
            <div class="col-define col-xs-4 col-md-4">{{propertyEnterpriseDetails.OperationScope}}</div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">其他营业范围</div>
            <div class="col-define col-xs-4 col-md-4">{{propertyEnterpriseDetails.MainBusiness}}</div>
          </div> -->
          <!-- <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">企业概况</div>
            <div class="col-define col-xs-4 col-md-4">{{RealtyMgeComPropertyObj.Introduction}}</div>
          </div> -->
          <!-- <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">业绩介绍</div>
            <div class="col-define col-xs-4 col-md-4">{{RealtyMgeComPropertyObj.Achievement}}</div>
          </div> -->
        </div>
      </div>
      <!-- second show -->
      <div v-show="activeName === 'second'" class="grid">
        <el-table
          ref="multipleTable"
          :data="EmployeeData"
          tooltip-effect="dark"
          style="width: 100%"
          height="100%"
          stripe
          border
          v-loading="employeeLoading"
          element-loading-text="数据正在加载中，请稍候"
        >
          <template slot="empty">
            <span v-if="employeeLoading"></span>
            <span v-else>暂无数据</span>
          </template>
          <el-table-column
            label="序号"
            width="60"
            type="index"
            v-bind:index="indexMethod"
            align="center"
          ></el-table-column>
          <el-table-column
            label="姓名"
            width="80"
            prop="FullName"
            show-overflow-tooltip
            header-align="center"
            align="left"
          >
          </el-table-column>
          <el-table-column
            label="性别"
            width="60"
            prop=""
            show-overflow-tooltip
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.Gender || '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="证件号码"
            width="300"
            prop="IDCardNumber"
            show-overflow-tooltip
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.IDCardNumber || '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="人员类型"
            min-width="100"
            prop="EmployeeType"
            show-overflow-tooltip
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.EmployeeType">{{
                (scope.row.EmployeeType &&
                  peopleType[0][scope.row.EmployeeType]) ||
                '--'
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="文化程度"
            width="100"
            prop="Education"
            show-overflow-tooltip
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.Education">{{
                (scope.row.Education && eductionType[0][scope.row.Education]) ||
                '--'
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="职称"
            width="100"
            prop="MajorType"
            show-overflow-tooltip
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.MajorType">{{
                (scope.row.MajorType && zyflType[0][scope.row.MajorType]) ||
                '--'
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="职称等级"
            width="80"
            prop="MajorTypeLevel"
            show-overflow-tooltip
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.MajorTypeLevel">{{
                scope.row.MajorTypeLevel || '--'
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="联系电话"
            width="150"
            prop="MobilePhone"
            show-overflow-tooltip
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.MobilePhone">{{
                (scope.row.MobilePhone &&
                  levelType[0][scope.row.MobilePhone]) ||
                '--'
              }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--  -->
      <div v-show="activeName === 'third'" class="grid">
        <el-table
          ref="multipleTable"
          :data="PrejectData"
          tooltip-effect="dark"
          style="width: 100%"
          height="100%"
          stripe
          border
          v-loading="projectLoading"
          element-loading-text="数据正在加载中，请稍候"
        >
          <template slot="empty">
            <span v-if="projectLoading"></span>
            <span v-else>暂无数据</span>
          </template>
          <el-table-column
            label="序号"
            width="60"
            type="index"
            v-bind:index="indexMethod"
            align="center"
          ></el-table-column>
          <!-- <el-table-column
            label="项目编码"
            width="180"
            prop="EaAreaCode"
            show-overflow-tooltip
            header-align="center"
            align="left"
          ></el-table-column> -->
          <el-table-column
            label="物业项目名称"
            prop="EaAreaName"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.EaAreaName || '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="项目所属区"
            prop=""
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.PropertyCantonName || '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="项目类型"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <!-- <span>{{ wuyeType[scope.row.ProjecType] || '--'}}</span> -->
              <span>{{ getEaAreaName(scope.row.HouseTypeCode) }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column
            label="项目地址"
            prop="PrejectAddress"
            show-overflow-tooltip
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            label="项目负责人"
            width="150"
            prop="PropertyManager"
            show-overflow-tooltip
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            label="联系电话"
            width="200"
            prop="PropertyManagerTel"
            show-overflow-tooltip
            header-align="center"
            align="center"
          ></el-table-column> -->
          <!-- <el-table-column
            label="项目所在区"
            width="150"
            prop="PropertyCantonName"
            show-overflow-tooltip
            header-align="center"
            align="center"
          ></el-table-column> -->
          <!-- <el-table-column
            label="建筑面积"
            width="150"
            prop="FloorArea"
            show-overflow-tooltip
            header-align="center"
            align="center"
          ></el-table-column> -->
        </el-table>
      </div>
      <div v-show="activeName === 'three'" class="grid">
        <el-table
          ref="multipleTable"
          :data="comDataList"
          tooltip-effect="dark"
          style="width: 100%"
          :cell-style="setDataStyle"
          @cell-click="clickData"
          height="100%"
          stripe
          border
          v-loading="comLoading"
          element-loading-text="数据正在加载中，请稍候"
        >
          <template slot="empty">
            <span v-if="comLoading"></span>
            <span v-else>暂无数据</span>
          </template>
          <el-table-column
            label="序号"
            width="80"
            type="index"
            v-bind:index="indexMethod"
            align="center"
          ></el-table-column>
          <el-table-column prop="OrgName" label="企业名称" align="center">
          </el-table-column>
          <el-table-column
            prop="OrgCode"
            label="统一社会信用代码"
            align="center"
          >
          </el-table-column>
          <el-table-column label="物业办公地址" align="center" prop="Address">
            <template slot-scope="scope">
              {{ scope.row.Address ? scope.row.Address : '--' }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--  -->
      <div v-show="activeName === 'four'" class="grid">
        <el-table
          ref="multipleTable"
          :data="creditData"
          tooltip-effect="dark"
          style="width: 100%"
          height="100%"
          stripe
          border
          v-loading="creditLoading"
          element-loading-text="数据正在加载中，请稍候"
        >
          <template slot="empty">
            <span v-if="creditLoading"></span>
            <span v-else>暂无数据</span>
          </template>
          <el-table-column
            label="序号"
            width="60"
            type="index"
            v-bind:index="indexMethod"
            align="center"
          ></el-table-column>
          <el-table-column
            label="项目名称"
            prop="EaAreaName"
            show-overflow-tooltip
            header-align="center"
            align="left"
          ></el-table-column>
          <el-table-column
            label="物业类别"
            width="100"
            prop="EaAreaType"
            show-overflow-tooltip
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.EaAreaType">{{
                scope.row.EaAreaType && wuyeType[scope.row.EaAreaType]
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="项目地址"
            prop="Address"
            show-overflow-tooltip
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            label="建筑面积"
            width="150"
            prop="BuildArea"
            show-overflow-tooltip
            header-align="center"
            align="center"
          ></el-table-column>
          <!-- <el-table-column
            label="物业管理费标准"
            width="200"
            prop="PropertyManagerTel"
            show-overflow-tooltip
            header-align="center"
            align="center"
          ></el-table-column>-->
          <el-table-column
            label="项目负责人姓名"
            width="150"
            prop="PeopleName"
            show-overflow-tooltip
            header-align="center"
            align="center"
          ></el-table-column>
        </el-table>
      </div>
      <!--  -->
      <div v-show="activeName === 'five'" class="grid">
        <el-table
          ref="multipleTable"
          :data="creditData"
          tooltip-effect="dark"
          style="width: 100%"
          height="100%"
          stripe
          border
          v-loading="creditLoading"
          element-loading-text="数据正在加载中，请稍候"
        >
          <template slot="empty">
            <span v-if="creditLoading"></span>
            <span v-else>暂无数据</span>
          </template>
          <el-table-column
            label="序号"
            width="60"
            type="index"
            v-bind:index="indexMethod"
            align="center"
          ></el-table-column>
          <el-table-column
            label="表彰名称"
            prop="ActionName"
            show-overflow-tooltip
            header-align="center"
            align="left"
          ></el-table-column>
          <el-table-column
            label="表彰等级"
            width="180"
            prop="ActionLevel"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            label="表彰类别"
            width="180"
            prop="ActionType"
            show-overflow-tooltip
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            label="表彰单位"
            width="180"
            prop="ActionOrg"
            show-overflow-tooltip
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            label="获得时间"
            width="150"
            prop="ActionDate"
            show-overflow-tooltip
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.ActionDate | formatDate('yyyy-MM-dd') }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--  -->
      <div v-show="activeName === 'sex'" class="grid">
        <el-table
          ref="multipleTable"
          :data="creditData"
          tooltip-effect="dark"
          style="width: 100%"
          height="100%"
          stripe
          border
          v-loading="creditLoading"
          element-loading-text="数据正在加载中，请稍候"
        >
          <template slot="empty">
            <span v-if="creditLoading"></span>
            <span v-else>暂无数据</span>
          </template>
          <el-table-column
            label="序号"
            width="60"
            type="index"
            v-bind:index="indexMethod"
            align="center"
          ></el-table-column>
          <el-table-column
            label="行为概述"
            prop="ActionSummary"
            show-overflow-tooltip
            header-align="center"
            align="left"
          ></el-table-column>
          <el-table-column
            label="详细描述"
            prop="ActionDetailSummary"
            show-overflow-tooltip
            header-align="center"
            align="left"
          ></el-table-column>
        </el-table>
      </div>
      <!--  -->
      <div v-show="activeName === 'seven'" class="grid">
        <el-table
          ref="multipleTable"
          :data="creditData"
          tooltip-effect="dark"
          style="width: 100%"
          height="100%"
          stripe
          border
          v-loading="creditLoading"
          element-loading-text="数据正在加载中，请稍候"
        >
          <template slot="empty">
            <span v-if="creditLoading"></span>
            <span v-else>暂无数据</span>
          </template>
          <el-table-column
            label="序号"
            width="60"
            type="index"
            v-bind:index="indexMethod"
            align="center"
          ></el-table-column>
          <el-table-column
            label="判决（仲裁）编号"
            width="180"
            prop="ActionFileNum"
            show-overflow-tooltip
            header-align="center"
            align="left"
          ></el-table-column>
          <el-table-column
            label="物业管理类的侵权或违约败诉行为"
            prop="ActionSummary"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            label="判决机构"
            width="150"
            prop="ActionOrg"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            label="判决时间"
            width="150"
            prop="ActionDate"
            show-overflow-tooltip
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.ActionDate | formatDate('yyyy-MM-dd') }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--  -->
      <div v-show="activeName === 'eight'" class="grid">
        <el-table
          ref="multipleTable"
          :data="creditData"
          tooltip-effect="dark"
          style="width: 100%"
          height="100%"
          stripe
          border
          v-loading="creditLoading"
          element-loading-text="数据正在加载中，请稍候"
        >
          <template slot="empty">
            <span v-if="creditLoading"></span>
            <span v-else>暂无数据</span>
          </template>
          <el-table-column
            label="序号"
            width="60"
            type="index"
            v-bind:index="indexMethod"
            align="center"
          ></el-table-column>
          <el-table-column
            label="文号"
            width="180"
            prop="ActionFileNum"
            show-overflow-tooltip
            header-align="center"
            align="left"
          ></el-table-column>
          <el-table-column
            label="违法行为"
            prop="ActionSummary"
            header-align="center"
            align="left"
          ></el-table-column>
          <el-table-column
            label="处罚种类"
            prop="ActionType"
            width="180"
            show-overflow-tooltip
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            label="处罚单位"
            width="150"
            prop="ActionOrg"
            show-overflow-tooltip
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            label="判决时间"
            prop="ActionDate"
            width="150"
            show-overflow-tooltip
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.ActionDate | formatDate('yyyy-MM-dd') }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div v-show="activeName != 'first' && activeName != 'three'" class="footer">
      <div class="page">
        <ps-page
          :page="page"
          @getData="
            activeName == 'third' ? getPrejectDetailData() : etEmployeeData()
          "
        ></ps-page>
      </div>
    </div>
    <!-- <div class="PublicInformationDetail-footer">
      <ps-close></ps-close>
    </div>-->
  </div>
</template>
<script>
import { PublicInterfaceInfoController } from '@/service/PublicInterfaceInfoController/PublicInterfaceInfoController.js';
import { OpenControllerSvr } from '@/service/OpenControllerSvr/OpenControllerSvr.js';
import { CommonControllerSvr } from '@/service/CommonControllerSvr/CommonControllerSvr.js';
import { OrganizationBaseSvr } from '@/service/OrganizationBaseSvr.js';
import {
  registrationType,
  holdingSituation,
  licenseLevel,
  accountingType,
  organizationType,
  companyType,
} from '@/enum/propertyEnterprise';
import { headerredraw } from '@/mixin/headerredraw';
import { mapState } from 'vuex';
import { Page } from '@/models/page';
import { EnumController } from '@/service/EnumController/EnumController.js';
export default {
  metaInfo: {
    title: '业主大会和业委会查询',
    meta: [
      {
        name: 'viewport',
        content:
          'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no',
      },
      { name: 'SiteName', content: '深圳市住房和建设局网站' },
      { name: 'SiteDomain', content: 'zjj.sz.gov.cn' },
      { name: 'SiteIDCode', content: '4403000005' },
      { name: 'ColumnName', content: '物业管理政策专题' },
      {
        name: 'ColumnDescription',
        content: '该栏目公布物业管理政策专栏的信息。',
      },
      { name: 'ColumnKeywords', content: '物业管理政策专栏' },
      { name: 'ColumnType', content: '其他' },
    ],
  },
  components: {},
  props: {},
  mixins: [headerredraw],
  data() {
    return {
      wuyeType: [],
      type: [],
      activeName: 'first',
      dataFeed: [],
      page: new Page(),
      orgCode: '',
      propertyEnterpriseDetails: {},
      RealtyMgeComPropertyObj: {},
      PrejectData: [],
      creditData: [],
      EmployeeData: [],
      AllTypeArray: [],
      zwpzType: [],
      eductionType: [],
      zyflType: [],
      levelType: [],
      ZCType: [],
      peopleType: [],
      paraNameArray: [
        '职务配置',
        '最高学历配置',
        '专业分类配置',
        '专业分类等级配置',
        '人员类型配置',
      ],
      registrationType: new registrationType(),
      holdingSituation: new holdingSituation(),
      licenseLevel: new licenseLevel(),
      accountingType: new accountingType(),
      organizationType: new organizationType(),
      companyType: new companyType(),
      houseTypeCodeList: [],
      isHeaderCompany: false,
      comDataList: [],
      employeeLoading: false,
      projectLoading: false,
      comLoading: false,
      creditLoading: false,
      detailLoading: false,
    };
  },
  computed: { ...mapState(['token']) },
  created() {
    this.OpenControllerSvr = new OpenControllerSvr();
    this.EnumController = new EnumController();
    this.CommonControllerSvr = new CommonControllerSvr();
    this.PublicInterfaceInfoController = new PublicInterfaceInfoController();
    this.OrganizationBaseSvr = new OrganizationBaseSvr();
    this.EnumController.getEnum('fixf.core.common.EPropertyType', false).then(
      (res) => {
        for (let item of res) {
          this.wuyeType[item.value] = item.label;
        }
      }
    );
    this.getHouseTypeCodeList();
    this.getAllType(this.paraNameArray);
  },
  mounted() {
    this.orgCode = this.$route.query.orgCode;
    this.getRealtyMgeComDetailData();
  },
  methods: {
    getEaAreaData(val) {
      this.eaAreaController
        .GetEaAreaDetail(this.userInfo.OpenId, val.EaAreaCode, true)
        .then((res) => {
          if (res.property) {
            for (var i = 0; i < this.dataList.length; i++) {
              if (this.dataList[i].EaAreaCode === res.EaAreaCode) {
                this.dataList[i].EaAreaType = res.property.EaAreaType;
                this.dataList[i].BuildArea = res.property.BuildArea;
                this.dataList[i].Address = res.Address;
              }
            }
          }
        });
    },
    handleClick(tab, event) {
      if (tab.name === 'second') this.getEmployeeData();
      if (tab.name === 'third') this.getPrejectDetailData();
      if (tab.name === 'four') {
        this.getEnumdata('fixf.core.common.EPropertyType', '1');
        //this.getEaAreaData();
      }
      if (tab.name === 'five') this.getCreditData(2);
      if (tab.name === 'sex') this.getCreditData(7);
      if (tab.name === 'seven') this.getCreditData(6);
      if (tab.name === 'eight') this.getCreditData(5);
    },
    getEnumdata(name, int) {
      this.type = [];
      let temporary;
      this.EnumController.getEnum(name, false).then((res) => {
        //this.type = res;
        temporary = [...[]];
        temporary[0] = '';
        for (let { label: label, value: value } of res) {
          temporary[value] = label;
        }
        this.type.push(temporary);
        this.getCreditData(int);
      });
    },
    showPara() {},
    indexMethod(index) {
      return index + 1 + (this.page.currentPage - 1) * this.page.currtNum;
    },
    //获取职务配置
    getzwpzType() {
      this.CommonControllerSvr.GetConfigValueList(this.paraNameArray[0]).then(
        (res) => {
          var temporary = [...[]];
          temporary[0] = '1';
          for (let { Key: key, Value: value } of res) {
            temporary[value] = key;
          }
          this.zwpzType.push(temporary);
        }
      );
    },
    //最高学历配置
    getEductionType() {
      this.CommonControllerSvr.GetConfigValueList(this.paraNameArray[1]).then(
        (res) => {
          var temporary = [...[]];
          temporary[0] = '1';
          for (let { Key: key, Value: value } of res) {
            temporary[value] = key;
          }
          this.eductionType.push(temporary);
        }
      );
    },
    //获取专业分类配置
    getzyflType() {
      this.CommonControllerSvr.GetConfigValueList(this.paraNameArray[2]).then(
        (res) => {
          var temporary = [...[]];
          temporary[0] = '1';
          for (let { Key: key, Value: value } of res) {
            temporary[value] = key;
          }
          this.zyflType.push(temporary);
        }
      );
    },
    //获取专业分类等级配置
    getlevelType() {
      this.CommonControllerSvr.GetConfigValueList(this.paraNameArray[3]).then(
        (res) => {
          var temporary = [...[]];
          temporary[0] = '1';
          for (let { Key: key, Value: value } of res) {
            temporary[value] = key;
          }
          this.levelType.push(temporary);
        }
      );
    },
    getPeopleType() {
      this.CommonControllerSvr.GetConfigValueList(this.paraNameArray[4]).then(
        (res) => {
          var temporary = [...[]];
          temporary[0] = '1';
          for (let { Key: key, Value: value } of res) {
            temporary[value] = key;
          }
          this.peopleType.push(temporary);
        }
      );
    },
    //获取所有值的类
    getAllType(paraNameArray) {
      this.getzwpzType();
      this.getEductionType();
      this.getzyflType();
      this.getlevelType();
      this.getPeopleType();
      let temporary;
      paraNameArray.map((currentValue, inedx) => {
        this.CommonControllerSvr.GetConfigValueList(currentValue)
          .then(
            (res) => {
              temporary = [...[]];
              temporary[0] = '';
              for (let { Key: key, Value: value } of res) {
                temporary[value] = key;
              }
              this.AllTypeArray.push(temporary);
            },
            (err) => {
              this.$message({
                message: err,
                type: 'error',
              });
            }
          )
          .catch(() => {});
      });
    },
    getEmployeeData() {
      this.employeeLoading = true;
      this.OpenControllerSvr.getEmployeeByOrgCode(
        this.orgCode,
        (this.page.currentPage - 1) * this.page.currtNum,
        this.page.currtNum
      )
        .then(
          (res) => {
            this.employeeLoading = false;
            this.page.getCurrtNum = res.TotalCount;
            this.EmployeeData = res._Items;
            for (var i = 0; i < this.EmployeeData.length; i++) {
              this.EmployeeData[i].IDCardNumber =
                this.EmployeeData[i].IDCardNumber.substr(0, 3) +
                '*****' +
                this.EmployeeData[i].IDCardNumber.substr(
                  this.EmployeeData[i].IDCardNumber.length - 3
                );
              this.EmployeeData[i].MobilePhone =
                this.EmployeeData[i].MobilePhone.substr(0, 3) +
                '****' +
                this.EmployeeData[i].MobilePhone.substr(7);
            }
          },
          (err) => {
            this.employeeLoading = false;
            this.$message({
              message: err,
              type: 'error',
            });
          }
        )
        .catch(() => {
          this.employeeLoading = false;
        });
    },
    getCreditData(specificType) {
      this.creditLoading = true;
      this.OpenControllerSvr.queryIntegrityInfo(
        this.orgCode,
        1,
        specificType,
        (this.page.currentPage - 1) * this.page.currtNum,
        this.page.currtNum
      )
        .then((res) => {
          this.creditLoading = false;
          this.creditData = res._Items;
          this.page.getCurrtNum = res.TotalCount;
        })
        .catch((err) => {
          this.creditLoading = false;
          this.$message({
            message: err,
            type: 'error',
          });
        });
    },
    // 获取在管项目列表
    getPrejectDetailData() {
      this.projectLoading = true;
      this.OpenControllerSvr.getPrejectList(
        this.orgCode,
        (this.page.currentPage - 1) * this.page.currtNum,
        this.page.currtNum
      )
        .then(
          (res) => {
            this.projectLoading = false;
            this.page.getCurrtNum = res.TotalCount;
            this.PrejectData = res._Items;
            for (var i = 0; i < this.PrejectData.length; i++) {
              this.PrejectData[i].PropertyManagerTel =
                this.PrejectData[i].PropertyManagerTel.substr(0, 3) +
                '****' +
                this.PrejectData[i].PropertyManagerTel.substr(7);
            }
          },
          (err) => {
            this.projectLoading = false;
            this.$message({
              message: err,
              type: 'error',
            });
          }
        )
        .catch(() => {
          this.projectLoading = false;
        });
    },
    // 获取产权性质和物业项目类型
    getHouseTypeCodeList() {
      this.CommonControllerSvr.GetHouseTypeCodeList(
        'BUILDING_HOUSE_AREA_TYPE_CODE',
        ''
      )
        .then((res) => {
          let typeArr = [];
          res._Items.forEach((item) => {
            if (item.ListChild.length <= 0) {
              delete item.ListChild;
            }
          });
          typeArr = res._Items;
          this.houseTypeCodeList = typeArr;
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err,
          });
        });
    },
    getEaAreaName(codes) {
      if (codes == '' || codes == null || codes == undefined || codes == 0) {
        return '--';
      }
      let nameArr = this.setTypePorpertyRights(codes);
      if (nameArr.length > 0) return nameArr.join();
    },
    // 递归调用回显项目类型、产权性质
    setTypePorpertyRights(codes) {
      const codeArr = codes.split(',');
      let nameArr = [];
      this.houseTypeCodeList.forEach((item) => {
        if (item.TypeCode == codeArr[0]) {
          nameArr.push(item.TypeName);
        }
        if (codeArr.length > 1 && item.ListChild && item.ListChild.length > 0) {
          item.ListChild.forEach((child) => {
            if (child.TypeCode == codeArr[1]) {
              nameArr.push(child.TypeName);
            }
          });
        }
      });
      if (nameArr.length > 0) return nameArr;
      else return [];
    },
    getRealtyMgeComDetailData() {
      this.detailLoading = true;
      this.OpenControllerSvr.getRealtyMgeComDetail(this.orgCode)
        .then(
          (res) => {
            this.detailLoading = false;
            this.propertyEnterpriseDetails = res.RealtyMgeComObj;
            if (this.propertyEnterpriseDetails.OfficePhone) {
              this.propertyEnterpriseDetails.OfficePhone =
                this.propertyEnterpriseDetails.OfficePhone.substr(0, 3) +
                '****' +
                this.propertyEnterpriseDetails.OfficePhone.substr(
                  this.propertyEnterpriseDetails.OfficePhone.length - 4
                );
            }
            if (this.propertyEnterpriseDetails.LegalRepTel) {
              this.propertyEnterpriseDetails.LegalRepTel =
                this.propertyEnterpriseDetails.LegalRepTel.substr(0, 3) +
                '****' +
                this.propertyEnterpriseDetails.LegalRepTel.substr(
                  this.propertyEnterpriseDetails.LegalRepTel.length - 4
                );
            }
            if (this.propertyEnterpriseDetails.Relations) {
              // Relations为空 是独立法人 是总公司
              // 总公司显示下属企业
              this.isHeaderCompany = false;
            } else {
              this.isHeaderCompany = true;
            }
            if (this.propertyEnterpriseDetails) {
              this.getRealtyMgeComListByParam(this.propertyEnterpriseDetails);
            }
            this.PublicInterfaceInfoController.getProvinceDetail(
              res.RealtyMgeComObj.RegisteredArea,
              false
            ).then((res1) => {
              this.propertyEnterpriseDetails.RegisteredArea = res1.Name;
            });
            this.RealtyMgeComPropertyObj = res.RealtyMgeComPropertyObj;
          },
          (err) => {
            this.detailLoading = false;
            this.$message({
              message: err,
              type: 'error',
            });
          }
        )
        .catch(() => {
          this.detailLoading = false;
        });
    },
    // 获取下属企业或者隶属企业
    getRealtyMgeComListByParam(obj) {
      this.comLoading = true;
      this.OrganizationBaseSvr.getRealtyMgeComListByParam(
        this.isHeaderCompany ? '' : obj.Relations,
        this.isHeaderCompany ? this.orgCode : '',
        0,
        999
      )
        .then((res) => {
          this.comLoading = false;
          if (res && res._Items) {
            this.comDataList = res._Items;
          }
        })
        .catch((error) => {
          this.comLoading = false;
          this.$message({
            type: 'error',
            message: error,
          });
        });
    },
    // 设置表格可点击数据样式
    setDataStyle({ row, column, rowIndex, columnIndex }) {
      if (column.property && column.property == 'OrgName')
        return 'color: #1890FF;cursor: pointer;';
    },
    // 点击表格数据
    clickData(row, column, cell, event) {
      this.orgCode = row.OrgCode;
      this.activeName = 'first';
      this.page.currentPage = 1;
      this.getRealtyMgeComDetailData();
    },
  },
};
</script>
<style lang="scss">
.el-tabs--border-card > .el-tabs__content {
  padding: 0px;
}
.InformationDetailPropertyEnterprisesList {
  .el-tabs__content {
    padding: 0px;
  }
}
</style>
<style lang="scss" scoped>
.PublicInformationDetail {
  height: 100%;
  .basInfo-table {
    overflow: auto;
    .row {
      margin-right: 0;
      margin-left: 0;
      @media screen and (max-width: 992px) {
        flex-wrap: wrap !important;
      }
      .col-define {
        font-size: 14px;
        line-height: 42px;
        min-width: 150px;
        overflow: hidden;
        color: #666;
        border-bottom: 1px solid #e2e2e2;
        .col-chld {
          display: inline-block;
          width: 25%;
          & > div:nth-child(1) {
            display: inline-block;
            width: 30%;
            vertical-align: top;
          }
          & > div:nth-child(2) {
            display: inline-block;
            width: 70%;
          }
        }
      }
      .col-define:nth-child(2n) {
        flex: 1;
        border-right: 1px dotted #e2e2e2;
        padding-left: 24px;
      }

      .col-define:nth-child(2n-1) {
        text-align: right;
      }

      .col-tips {
        border-right: 1px dotted #e2e2e2;
      }
    }
  }
  .PublicInformationDetail-footer {
    text-align: right;
    margin: 20px;
  }
}
.InformationDetailPropertyEnterprisesList {
  width: 100%;
  box-sizing: border-box;
  .header-seacher {
    @media screen and (max-width: 992px) {
      min-width: 0 !important;
      overflow-x: scroll;
    }
  }
  .function {
    min-width: 400px;
  }
  .container-boot {
    width: 100%;
    padding-right: 10px;
    padding-left: 10px;
    transition: height 0.3s;
    .container-header {
      width: 100%;
      padding-top: 10px;
      box-sizing: border-box;
    }
    .grid {
      height: calc(100% - 30px);
    }
  }
  .footer {
    display: flex;
    flex-direction: row-reverse;
    margin-right: 10px;
    .fun {
      font-size: 14px;
      color: #409eff;
      cursor: pointer;
      .delete {
        margin-left: 20px;
      }
    }
  }
}
</style>
